module.exports = __webpack_public_path__ + "img/emily-blackwell.4aa66cc9.png";